import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../../Atoms/Typography'
import Icon from '../../../Atoms/Icon'

import theme from '../../../../styles/theme'

const Container = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: ${props => props.minimised ? 'center' : 'flex-start'};
  padding: ${1.5 * theme.gutterUnit}px ${2 * theme.gutterUnit}px;
`

export default class SidebarOption extends PureComponent {
  render () {
    const { title, logo, active, minimised, fontSize } = this.props
    let containerStyles = {}
    if (active) {
      containerStyles = {
        backgroundColor: theme.colours.primary
      }
    }
    return (
      <Container style={containerStyles} minimised={minimised}>
        {/* Android device doesnt seem to rerender when the icon size changes  */}
        {minimised && <Icon size='xxxl' colour={active ? theme.colours.black : null} name={logo} />}
        {!minimised && <Icon size='m' colour={active ? theme.colours.black : null} name={logo} />}
        {!minimised && (
          <Text
            size={fontSize} white={!active} overrides={{
              marginLeft: 1.5 * theme.gutterUnit
            }}
          >{title}
          </Text>
        )}
      </Container>
    )
  }
}
